import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { idealistRequireAuthentication } from '#/modules/auth/routing/idealist-require-authentication';
import { orgDashboardAdminsLinksRoute } from '#/modules/orgDashboard/routing/org-select.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { AdminsLinksLoadable } from './AdminsLinksLoadable';

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof orgDashboardAdminsLinksRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    AdminsLinksLoadable.load(),
  ]);

  if (!user) return idealistRequireAuthentication({ request, context });
}

export default function OrgDashboardAdminsLinksHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: page to choose organization to see administrators page */
        i18n('Administrators')
      }
    >
      <AdminsLinksLoadable />
    </RouteModule>
  );
}
